import { Base64 }  from 'js-base64';

/*
  window.location.origin polyfill
 */
export const getLocationOrigin = (version) => {
  // if (!window.location.origin) {
  //   window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
  // }
  switch (version) {
      case 0:
          return "https://api.sporthood.in";
          // return "http://localhost:8888";
          break;
      case 2:
          return "https://api.sporthood.in/api/v2";
          // return "http://localhost:8888/api/v2";
          break;
      default:
          return "https://api.sporthood.in/api/v1";      
  }
  // return "http://localhost:8000/api/v1";
};

/*
  query options:
 */
export const defaultOptions = {
  credentials: 'include'
};

export const postMethod = {
  method: 'POST'
};

export const jsonHeader = {
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
};

export const multipartJsonHeader = {
  headers: {
    'Accept': 'application/json',
    // 'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
};

/*
  query response helpers:
 */
export const checkStatus = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  let body = null;
  try {
    body = await response.clone().json();
  } catch (e) {
    // non-JSON error body, fall back to statusText below
  }
  const error = new Error((body && (body.message || body.detail)) || response.statusText);
  error.response = response;
  error.status = response.status;
  error.body = body;
  // Present on both @ratelimit (Retry-After header only) and @backoff
  // (header + retry_after_seconds in the body) responses.
  const retryAfterHeader = response.headers.get('Retry-After');
  error.retryAfter = retryAfterHeader ? Number(retryAfterHeader) : (body && body.retry_after_seconds) || null;
  return Promise.reject(error);
};

export const parseJSON = (response) => {
  console.log(response);
  return response.json();
};

/*
 general helpers
 */
export const encodeBase64 = (stringToEncode) => {
  return Base64.encode(stringToEncode);
};



// WEBPACK FOOTER //
// ./src/app/services/fetchTools.js